export default __webpack_public_path__ + "static/media/CERP-mobi.7424413f.png";